import script from "./pressDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./pressDialog.vue?vue&type=script&setup=true&lang=js"

import "./pressDialog.vue?vue&type=style&index=0&id=84f5689c&lang=scss"

const __exports__ = script;

export default __exports__